import { ExternalConnection } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateExternalConnection } from 'shared/services/backend-api';

import { queryKey as externalEventsQueryKey } from './use-external-calendar-events-query';

export const useUpdateExternalConnectionMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (
      externalConnection: Pick<ExternalConnection, 'id'> &
        Partial<ExternalConnection>,
    ) => {
      await updateExternalConnection(externalConnection);
      // not snapshot-backed — manual invalidate required so the derived
      // external-calendar-events query re-fetches after a visibility change.
      await client.invalidateQueries({ queryKey: [externalEventsQueryKey] });
    },
  });
};
